import { createTheme } from '@mui/material/styles';
import { common as commonColors } from '@mui/material/colors';

const components = {
  MuiCssBaseline: {
    styleOverrides: {
      html: {
        fontSize: '62.5%',
      },
      '@media (max-width: 767px)': {
        html: {
          fontSize: '50%',
        },
      },
    },
  },
  // Keep the v4 default; v5 changed it to 'always'.
  MuiLink: {
    defaultProps: {
      underline: 'hover' as const,
    },
  },
  // Keep the v4 'default' (grey) button color; v5 changed the default
  // to 'primary'. 'inherit' renders the old grey for contained buttons.
  MuiButton: {
    defaultProps: {
      color: 'inherit' as const,
    },
  },
  // Keep the v4 default radio color; v5 changed it to 'primary'.
  MuiRadio: {
    defaultProps: {
      color: 'secondary' as const,
    },
  },
  // Keep the 24px padding that Stepper lost in v5.
  MuiStepper: {
    styleOverrides: {
      root: {
        padding: 24,
      },
    },
  },
  // Keep the v4 56px icon column; later majors shrank it to spacing(4.5).
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: 56,
      },
    },
  },
};

export const muiTheme = {
  print: createTheme({
    components,
    typography: {
      h1: {
        fontSize: '2.25rem',
        lineHeight: '2.5rem',
      },
      h2: {
        fontSize: '1.875rem',
        lineHeight: '2.25rem',
      },
      h3: {
        fontSize: '1.5rem',
        lineHeight: '2rem',
      },
      h4: {
        fontSize: '1.25rem',
        lineHeight: '1.75rem',
      },
      h5: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
      },
      body1: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
      },
      body2: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
      },
      htmlFontSize: 16,
      fontSize: 16,
    },
  }),
  display: createTheme({
    components,
    palette: {
      primary: {
        main: '#55cd8a',
        contrastText: commonColors.white,
      },
      secondary: {
        main: '#3168a3',
        contrastText: commonColors.white,
      },
      error: {
        main: '#a94442',
      },
      text: {
        primary: '#333',
      },
      background: {
        paper: commonColors.white,
        default: '#f8f8f8',
      },
    },
    typography: {
      fontFamily: 'Montserrat, sans-serif',
      htmlFontSize: 10,
      fontSize: 13,
      h1: {
        color: '#36495d',
        fontWeight: 600,
        fontSize: '2.1rem',
      },
      h2: {
        color: '#455C72',
        fontWeight: 600,
        fontSize: '1.8rem',
      },
      h3: {
        color: '#36495d',
        fontWeight: 600,
        fontSize: '1.4rem',
      },
      h4: {
        color: '#646C79',
        fontWeight: 600,
        fontSize: '1.4rem',
      },
      h5: {
        color: '#646C79',
        fontWeight: 600,
        fontSize: '1.4rem',
      },
      fontWeightLight: 400,
      fontWeightRegular: 400,
      fontWeightMedium: 600,
      fontWeightBold: 600,
    },
  }),
};
